var React = require('react');

function Love (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0-2h32v32H0z","key":0}),React.createElement("path",{"stroke":"#4E9267","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M28.604 3.396A8.182 8.182 0 0 0 16 4.661 8.182 8.182 0 1 0 3.396 14.968L16 27.571l12.604-12.604a8.182 8.182 0 0 0 0-11.571z","key":1})]));
}

Love.defaultProps = {"width":"32","height":"29","viewBox":"0 0 32 29"};

module.exports = Love;

Love.default = Love;
